import type { TemplateOnlyComponent } from '@ember/component/template-only';

const CoachingCoachesTemplate: TemplateOnlyComponent = <template>
  {{outlet}}
</template>;

export default CoachingCoachesTemplate;
